export default {
    NO_GENRE: "No Genre",
    ELECTRONIC: "Electronic",
    HIPHOP: "Hip-Hop/Rap",
    JAZZ: "Jazz",
    POP: "Pop",
    ROCK_METAL_PUNK: "Rock/Metal/Punk",
    URBAN_RNB: "Urban/R&B",
};
